import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import AppLayout from '../../../../../layout/components/AppLayout';
import customerServices from '../customerServices';
import moment from 'moment';
import CustomerAddressForm from '../components/CustomerAddressForm';
import { useAppData } from '../../../../../context/AppDataContext';
import customerAddressServices from '../customerAddressServices';

function CustomerDetailsPage() {
    const {id} = useParams();
    const {getMasterLabel} = useAppData();
    const [customerDetails,setCustomerDetails] = useState();
    const getCustomerDetails = () =>{
        customerServices.getById(id).then(res=>{
            setCustomerDetails(res.data);
        }).catch(error=>{

        })
    }

    const [customerAddressList,setCustomerAddressList] = useState(null);
    const getCustomerAddressList = () =>{
        customerAddressServices.getByCustomerId(id).then(res=>{
            setCustomerAddressList(res.data);
        })
    }

    useEffect(()=>{
        getCustomerDetails();
        getCustomerAddressList();
    },[id])

    return (
        customerDetails &&
        <AppLayout>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-3'>
                    </div>
                    <div className='col-md-9'>
                        <div className='card mb-2'>
                            <div className='card-body'>
                                <table className='table'>
                                    <tbody>
                                        <tr>
                                            <th>Customer Name</th>
                                            <td>{customerDetails.customerName}</td>
                                            <th>Customer Org</th>
                                            <td>{customerDetails.customerOrg}</td>
                                        </tr>
                                        <tr>
                                            <th>Customer GST</th>
                                            <td>{customerDetails.gst}</td>
                                            <th>Customer Since</th>
                                            <td>{moment(customerDetails.created_at).format("LL")}</td>
                                        </tr>

                                        <tr>
                                            <th>Customer Phone</th>
                                            <td>{customerDetails.phone}</td>
                                            <th>Customer Email</th>
                                            <td>{customerDetails.email}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        { customerAddressList && customerAddressList.length == 0 &&
                            <div className='card mb-2'>
                                <div className='card-body text-center'>No Address Found</div>
                            </div>
                        }

                        {customerAddressList && customerAddressList.map(customerAddress=>
                            <div className='card mb-2'>
                                <div className='card-body'>
                                    <div className='float-end'>
                                        <CustomerAddressForm customerId={customerDetails.id} data={customerAddress} callback={getCustomerAddressList} />
                                    </div>
                                    <div>{customerAddress.contactPerson}</div>
                                    <div>{customerAddress.address}</div>
                                    <div>{customerAddress.city}, { getMasterLabel("indian-state",customerAddress.state) }, {customerAddress.zip}</div>
                                    <div>{customerAddress.phone}, {customerAddress.email}</div>
                                </div>
                            </div>
                        )}

                        <div className='card'>
                            <div className='card-body text-center'>
                                <CustomerAddressForm customerId={customerDetails.id} callback={getCustomerDetails} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default CustomerDetailsPage